"use client";
import Image from "next/image"
import Link from "next/link";
import { useLanguage } from "@/utils/LanguageContext";

import breadcrumbShape_1 from "@/assets/img/bg/contact.png";
import breadcrumbShape_2 from "@/assets/img/images/breadcrumb_shape02.png";

const Breadcrumb = ({ title }: any) => {
   const { t, lang } = useLanguage();
   return (
      <section className="breadcrumb-area breadcrumb-bg" style={{ backgroundImage: `url(/assets/img/bg/bg-gradient1-1.png)` }}>
         <div className="container">
            <div className="row">
               <div className="col-lg-12">
                  <div className="breadcrumb-content">
                     <h2 className="title">{t(title)}</h2>
                     {title === "Contact" && (
                        <Image
                           src={breadcrumbShape_1}
                           alt=""
                           className="alltuchtopdown"
                           style={{ color: "transparent", height: "150px", width: "150px" }}
                        />
                     )}
                     <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                           <li className="breadcrumb-item"><Link href={`/${lang}/home`} prefetch={false}>{t("Home")}</Link></li>
                           <li className="breadcrumb-item active" aria-current="page">{t(title)}</li>
                        </ol>
                     </nav>
                  </div>
               </div>
            </div>
         </div>
         <div className="breadcrumb-shape-wrap">
            <Image src={breadcrumbShape_2} alt="" className="rotateme" />
         </div>
      </section>
   )
}

export default Breadcrumb
